<template>
  <v-container class="Profilinterface">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-box-multiple</v-icon>{{$t('administration.profil.profilinterface')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfilinterfaceForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </v-sheet>
</v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfilinterfaceForm from '../../components/profilinterface/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfilInterface';

const { mapFields } = createHelpers({
  getterType: 'profilinterface/getField',
  mutationType: 'profilinterface/updateField'
});

export default {
  name: 'ProfilInterfaceCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfilinterfaceForm
  },
  data() {
    return {
      item: {
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profilinterface', ['create', 'reset'])
  }
};
</script>
